import React from 'react';
import { Icon } from '@haldor/ui';
import Moment from 'moment';

var TimeLineButton = function TimeLineButton(props) {
  var handleClick = function handleClick() {
    props.toggleTimeButton();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "timeLine-button"
  }, /*#__PURE__*/React.createElement("div", {
    className: "add-placeholder-button"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dots"
  }, /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("button", {
    className: "content-container",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-container"
  }, props.open ? /*#__PURE__*/React.createElement(Icon, {
    name: "minus"
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  })), /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, Moment.utc(props.time).local().format('LT')))));
};

export default TimeLineButton;